import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import RichMediaBanner from "../../../../V2/Sections/Banners/RichMedia"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokRichMediaBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.RichMediaBanner>) => {
  return (
    <RichMediaBanner
      titleText={blok.headerText}
      bodyText={blok.bodyText}
      buttonLink={storyblokLinkToYocoLink(blok.primaryCTALink)}
      buttonText={blok.primaryCTAText}
      buttonBackgroundColor={blok.primaryCTAColor}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      mobileImageAlt={blok.mobileImage?.alt}
      mobileImageUrl={blok.mobileImage?.filename}
      contentAlignment={blok.contentAlignment}
      textColor={blok.textColor}
      showDownloadAppButton={blok.showDownloadAppButton}
      mobileGridOrder={mobileGridOrder}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokRichMediaBanner
